import React, { useState } from "react";
import {
  Typography,
  Grid,
  Toolbar,
  AppBar,
  Box,
  Container,
  useTheme,
} from "@mui/material";
//import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Popover from "../popover/Popover";
function Footer() {
  const [isPopoverVisible, setPopoverVisible] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation();
  const handleMouseEnter = () => {
    setPopoverVisible(true);
  };

  const handleMouseLeave = () => {
    setPopoverVisible(false);
  };

  return (
    <Box
      sx={{
        height: "auto",
        backgroundColor: "color.magentaDark1",
        [theme.breakpoints.up("sm")]: {
          padding: "6.3rem 0",
        },
        [theme.breakpoints.down("sm")]: {
          padding: "5rem 1rem",
        },
        position: "relative",
      }}
    >
      <Grid container direction="row">
        <Grid item xs={12} sm={3}>
          <Typography align="center">
            <img
              src="/assets/icons/brand-white.svg"
              style={{ width: "10rem" }}
            />
            <Typography
              sx={{
                color: "color.white",
                fontWeight: "bold",
                fontFamily: "Futura !important",
              }}
              variant="h2"
              paddingTop="1rem !important"
            >
              {"FutureCare"}
            </Typography>
            <Typography
              sx={{
                color: "color.white",
                fontFamily: "WixMadefor",
              }}
              variant="subtitle1"
              paddingTop="3rem !important"
              fontSize="0.89rem"
            >
              {"2023 © Copyright Volksbank Digital Solutions GmbH"}
            </Typography>
            <Typography
              sx={{
                color: "color.white",
                fontFamily: "WixMadefor",
              }}
              variant="subtitle1"
              fontSize="0.89rem"
            >
              {"All rights reserved."}
            </Typography>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography
            color="color.white"
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              fontFamily: "WixMadefor",
            }}
          >
            {t("footer.company")}
          </Typography>
          <Link
            to={"/about"}
            key={1}
            style={{
              textDecoration: "none",
            }}
            target={"_blank"}
          >
            <Typography
              color="color.white"
              variant="subtitle1"
              paddingTop="1rem !important"
              fontFamily="WixMadefor"
            >
              {t("footer.about")}
            </Typography>
          </Link>
          <Link
            to={"/faq"}
            key={3}
            style={{
              textDecoration: "none",
            }}
            target={"_blank"}
          >
            <Typography
              color="color.white"
              variant="subtitle1"
              fontFamily="WixMadefor"
            >
              {t("footer.faq")}
            </Typography>
          </Link>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography
            color="color.white"
            variant="subtitle1"
            fontFamily="WixMadefor"
            fontWeight="bold"
          >
            {t("footer.other")}
          </Typography>
          <Link
            to={"/imprint"}
            key={1}
            style={{
              textDecoration: "none",
            }}
            target={"_blank"}
          >
            <Typography
              color="color.white"
              variant="subtitle1"
              paddingTop="1rem !important"
              fontFamily="WixMadefor"
            >
              {t("footer.imprint")}
            </Typography>
          </Link>
          {localStorage.getItem("auth") && (
            <Link
              to={"/term-of-use"}
              key={2}
              style={{
                textDecoration: "none",
                cursor: "pointer",
              }}
              target={"_blank"}
            >
              <Typography
                color="color.white"
                variant="subtitle1"
                fontFamily="WixMadefor"
              >
                {t("footer.term-of-use")}
              </Typography>
            </Link>
          )}
          <Link
            to={"/privacy-policy"}
            key={2}
            style={{
              textDecoration: "none",
            }}
            target={"_blank"}
          >
            <Typography
              color="color.white"
              variant="subtitle1"
              fontFamily="WixMadefor"
            >
              {t("footer.privacy-policy")}
            </Typography>
          </Link>
          <Typography
            color="color.white"
            variant="subtitle1"
            fontFamily="WixMadefor"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            sx={{ cursor: "pointer" }}
          >
            {t("footer.disclaimer")}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography
            color="color.white"
            variant="subtitle1"
            fontFamily="WixMadefor"
            fontWeight="bold"
          >
            {t("footer.contact")}
          </Typography>
          <Typography
            color="color.white"
            variant="subtitle1"
            paddingTop="1rem !important"
            fontFamily="WixMadefor"
          >
            {"info@volksbank.solutions"}
          </Typography>
        </Grid>
        {isPopoverVisible && (
          <Popover content="Die Nutzung von FutureCare kann und soll eine Rechts- und Steuerberatung nicht ersetzen. FutureCare bietet lediglich Informationen rund um die Generationenberatung sowie Funktionen, um eine Übersicht zum Thema zu erhalten sowie den eigenen etwaigen (Rechts- und Steuer-) Beratungsbedarf zu erkennen und einzuordnen." />
        )}
      </Grid>
    </Box>
  );
}
export default Footer;
